/**
 * Pixel values for the buy flow layout.
 */
export const buyFlowLayout = {
	MOBILE_GUTTER: 20,
	DESKTOP_CONTENT_WIDTH: 558,
	DESKTOP_ASIDE_WIDTH: 125,
	DESKTOP_HORIZONTAL_GAP: 27,
};
